import { isMockServices } from 'src/utils';
import mock from '../utils/mock';
import { UserTask } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface UpdateUserTaskByIdBody {
  status?: 'open' | 'closed';
  description?: string;
}

export interface UpdateUserTaskByIdResponse {
  success: boolean;
  task: UserTask;
}

const mockUpdateUserTaskByIdResponse: UpdateUserTaskByIdResponse = {
  success: true,
  task: {
    id: 'mock-task-id',
    name: 'Mock Task',
    status: 'open',
    priority: 'low',
    description: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    isDeleted: false,
  },
};

const updateUserTaskById = async (
  id: string,
  body: UpdateUserTaskByIdBody,
): Promise<UpdateUserTaskByIdResponse> => {
  if (isMockServices()) {
    return await mock(mockUpdateUserTaskByIdResponse, {
      delay: 300,
      failureRate: 0,
    });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateUserTaskByIdResponse>(
    `/userTasks/${id}`,
    {
      method: 'PUT',
      body,
    },
  );

  if (response.data) return response.data;

  throw new Error('Failed to update user task');
};

export default updateUserTaskById;
